import validate, { checkRequiredField } from 'common/formValidation/lib';

// form validation for the management act creation form
const formValidate = validate(() => {
    // validators for the form
    const validators = [
        checkRequiredField('compagnyChoice'),
        checkRequiredField('operationType'),
        checkRequiredField('contractNumber'),
    ];

    return validators;
});

export default formValidate;
